import { useState } from "react";
import { Image, Button, Divider, Flex, Spacer, VStack } from "@chakra-ui/react";
import { DownloadIcon } from "@chakra-ui/icons";
import { useToast } from "@chakra-ui/react";

import { saveSVG, saveSvgAsPng } from "../utils/saveSvg";
import { WAIT_CONFIRMS } from "../utils/consts";
import safeGetParams from "../utils/safeGetParams";

const PNG_SIZE = 500;

export default function FeedItem({ contract, token, onFeeded, setPageIsLoading }) {
    const toast = useToast();
    const { tokenId, svg, name, age, isAlive } = token;
    const [loading, setLoading] = useState(false);

    function downloadSvg(svgText, name, age) {
        saveSVG(svgText, `${name}_age${age}.svg`);
    }

    function downloadPng(svgText, name, age) {
        saveSvgAsPng(svgText, `${name}_age${age}.png`, PNG_SIZE, PNG_SIZE);
    }

    function showToast(mode, name, description) {
        if (mode === "wait") {
            console.log(`Transaction: Feed ${name}`, description);
            toast({
                title: `Transaction: Feed ${name}`,
                description,
                status: "info",
                duration: 10000,
                isClosable: true,
            });
        } else if (mode === "success") {
            console.log(`Success: Feed ${name}`, description);
            toast({
                title: `Success: Feed ${name}`,
                description,
                status: "success",
                duration: 10000,
                isClosable: true,
            });
        } else if (mode === "error") {
            console.log(`Error: Feed ${name}`, description);
            toast({
                title: `Error: Feed ${name}`,
                description,
                status: "error",
                duration: 10000,
                isClosable: true,
            });
        }
    }
    async function feed() {
        setPageIsLoading(true);
        setLoading(true);
        try {
            const params = await safeGetParams(contract, tokenId);
            if (params.error) {
                showToast("error", name, params.error);
            } else if (!params.isAlive) {
                showToast("error", name, "Already dead");
            } else {
                const tx = await contract.feed(tokenId);
                showToast("wait", name, tx.hash);
                const receipt = await tx.wait(WAIT_CONFIRMS);
                showToast("success", name, receipt.transactionHash);
                onFeeded();
            }
        } catch (error) {
            showToast("error", name, error.message);
        } finally {
            setLoading(false);
            setPageIsLoading(false);
        }
    }

    return (
        <VStack>
            <Image
                boxSize="300"
                src={svg ? `data:image/svg+xml;charset=utf-8;base64,${Buffer.from(svg).toString("base64")}` : ""}
            />
            <Flex w={300}>
                {svg && (
                    <>
                        <Button
                            aria-label="SVG"
                            leftIcon={<DownloadIcon />}
                            onClick={() => downloadSvg(svg, name, age)}
                            size="xs"
                            mr="1"
                        >
                            SVG
                        </Button>
                        <Button
                            aria-label="PNG"
                            leftIcon={<DownloadIcon />}
                            onClick={() => downloadPng(svg, name, age)}
                            size="xs"
                        >
                            PNG
                        </Button>
                    </>
                )}
                <Spacer />
                <Button
                    aria-label="Feed"
                    visibility={isAlive ? "visible" : "hidden"}
                    colorScheme="orange"
                    disabled={loading}
                    isLoading={loading}
                    loadingText="Feeding"
                    onClick={() => feed()}
                >
                    Feed
                </Button>
            </Flex>
            <Divider />
        </VStack>
    );
}
